const clock = {
    getCurrentTime() {
        return Date.now();
    },
};

export default clock;
